<template>
  <div class="bg-gray-50 border-b border-gray-200 flex" aria-label="Breadcrumb">
    <ol class="max-w-screen-xl w-full mx-auto px-4 pb-4 flex space-x-4 sm:px-6 lg:px-8">
      <li>
        <div>
          <router-link to="/" class="text-gray-400 hover:text-gray-500">
            <svg class="flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
            <span class="sr-only">Home</span>
          </router-link>
        </div>
      </li>
      <li v-for="page in pages" :key="page.name" class="flex">
        <div class="flex items-center">
          <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
          <router-link :to="page.to" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700" :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
        </div>
      </li>
      <li class="flex">
        <div class="flex items-center">
          <svg class="flex-shrink-0 h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
          </svg>
          <router-link :to="currentRoute" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700" :aria-current="true">{{ job.title }}</router-link>
        </div>
      </li>
    </ol>
  </div>
  <div class="bg-white shadow overflow-hidden sm:rounded-lg">
    <div class="relative py-8 overflow-hidden">
      <div class="mx-auto max-w-md px-4 pb-12 text-center sm:max-w-3xl sm:px-6 lg:px-8 lg:max-w-7xl">
        <div class="px-4 py-5 sm:px-6">
          <h1 class="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-4xl">
            {{ job.title }}
          </h1>
          <p class="mt-1 text-center text-gray-500">
            {{ job.content.tagLine }}
          </p>
        </div>
        <div class="border-t border-gray-200 px-4 pt-3 sm:px-6">
        </div>
        <div class="">
          <p class="py-5 text-xl text-gray-900 leading-normal">
            {{ job.content.overview }}
          </p>
        </div>
        <div class="grid grid-flow-col grid-cols-1 grid-rows-3 text-left">
          <div>
            <p class="mt-4 text-base font-semibold tracking-wider text-awtmtn-blue uppercase">Opened on</p>
            <p class="">
              {{ job.meta.date }}
            </p>
          </div>
          <div>
            <p class="mt-4 text-base font-semibold tracking-wider text-awtmtn-blue uppercase">Location</p>
            <p class="">
              {{ job.meta.location }}
            </p>
          </div>
          <div>
            <p class="mt-4 text-base font-semibold tracking-wider text-awtmtn-blue uppercase">Full / Part Time</p>
            <p class="">
              {{ job.meta.time }}
            </p>
          </div>
        </div>
        <!-- Sections -->
        <div v-for="section in job.content.sections" :key="section.title">
          <h3 class="text-4xl text-left mt-8 font-extrabold text-gray-900 tracking-tight sm:text-2xl">
            {{ section.title }}
          </h3>
          <div v-if="section.type == 'list'" class="mt-2 px-8 text-gray-600 mx-auto text-left text-lg">
            <ul class="text-left list-disc">
              <li v-for="content in section.content" :key="content" class="text-left mt-2">
                {{ content }}
              </li>
            </ul>
          </div>
          <div v-if="section.type == 'text'" class="mt-2 px-8 text-gray-600 mx-auto text-left text-lg">
            <p class="mt-2 text-xl text-gray-500 leading-8 text-left">
              {{ section.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fixed bottom-0 inset-x-0 pb-2 sm:pb-5">
    <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
      <div class="p-2 rounded-lg bg-awtmtn-blue shadow-lg sm:p-3">
        <div class="flex items-center justify-between flex-wrap">
          <div class="w-0 flex-1 flex items-center">
            <span class="flex p-2 rounded-lg bg-awtmtn-blue">
              <font-awesome-icon icon="user-plus" class="h-6 w-6 text-white" aria-hidden="true" />
            </span>
            <p class="ml-3 font-medium text-white truncate">
              <span class="md:hidden">
                Interested? Send your resume to <strong>work@awetomaton.com</strong>.
              </span>
              <span class="hidden md:inline">
                Interested in joining our team? Send your resume to <strong>work@awetomaton.com</strong>.
              </span>
            </p>
          </div>
          <div class="order-3 mt-2 flex-shrink-0 w-full sm:order-2 sm:mt-0 sm:w-auto">
            <a :href="'mailto:work@awetomaton.com?subject=Application for '+ job.title + ' position&body=Include your resume and a bit about yourself.'" class="flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-awtmtn-blue bg-white hover:bg-awtmtn-lite-blue">
              Email
            </a>
          </div>
          <div class="order-2 flex-shrink-0 sm:order-3 sm:ml-2">
            <button type="button" class="-mr-1 flex p-2 rounded-md hover:bg-awtmtn-blue focus:outline-none focus:ring-2 focus:ring-white">
              <span class="sr-only">Dismiss</span>
              <font-awesome-icon icon="xmark" class="h-6 w-6 text-white" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { JobPostings } from '../data/job-reqs.json'

export default {
  components: {},
  computed: {
    job: function() {
      let slug = this.$route.params.slug
      let j = JobPostings.Content.filter(function(job){
        return (job.slug == slug)
      })

      return j[0]
    },
    pages: function() {
        let p = [
            { name: 'Careers', to: '/careers', current: false }
        ]
        return p
    },
    currentRoute: function() {
        return this.$route.path;
    }
  },
  created: function() {
      this.noJobReturn404()
  },
  methods: {
      noJobReturn404() {
        if (!this.job) {
          window.location.href = "/404";
        }
      }
  },
  setup() {
    return {
    }
  },
}
</script>